import pmImg1 from "public/images/landing/sellingPoint/pm_1.png";
import pmImg2 from "public/images/landing/sellingPoint/pm_2.png";
import pmImg3 from "public/images/landing/sellingPoint/pm_3.png";
import mktImg1 from "public/images/landing/sellingPoint/mkt_1.png";
import mktImg2 from "public/images/landing/sellingPoint/mkt_2.png";
import mktImg3 from "public/images/landing/sellingPoint/mkt_3.png";

export const PMSellingPointTitle = () => {
  return (
    <>
      13주 뒤에는 이런 역량을
      <br />
      나의 경험으로 풀어낼 수 있습니다.
    </>
  );
};

export const pmSellingPointData = [
  {
    img: pmImg1,
    title: "프레임워크를 통한\n의사결정 능력",
    desc:
      "실무에 기반한 프레임워크를 바탕으로, 제품을\n" +
      "성공으로 이끄는 의사결정 능력을 기릅니다.",
  },
  {
    img: pmImg2,
    title: "개발 지식에 기반을 둔\n" + "IT 프로세스 이해 능력",
    desc:
      "탁월한 PM은 소통에 뛰어납니다. 개발을 이해하면\n" +
      "프로덕트를 만드는 사람과 잘 소통할 수 있습니다.",
  },
  {
    img: pmImg3,
    title: "프로덕트 성장의 A to Z를\n" + "주도적으로 이끄는 능력",
    desc:
      "기획, 운영에서 멈추지 않습니다. 실전 프로젝트를\n" +
      "통해 제품의 생애주기 전반을 경험합니다.",
  },
];

export const MktSellingPointTitle = () => {
  return (
    <>
      3개월 간 데이터 마케팅을 경험하며
      <br />
      실전에 강한 그로스 역량을 <br className={"mk-mo"} />
      갖추세요.
    </>
  );
};

export const mktSellingPointData = [
  {
    img: mktImg1,
    title: "팀별 예산을 활용해\n" + "실제 마케팅까지 집행합니다.",
    desc:
      "모의 프로젝트가 아닙니다. 프로덕트의 탄생부터\n" +
      "마케팅 실무까지, 실전의 A to Z를 경험합니다.",
  },
  {
    img: mktImg2,
    title: "데이터에 기반한\n의사결정 구조를 학습합니다. ",
    desc: "날카로운 직관에 논리적인 근거를 더해보세요.\n데이터에 기반한 탄탄한 전략은 성공으로 이어집니다.",
  },
  {
    img: mktImg3,
    title: "현직 마케터의 밀착 코칭으로\n" + "밀도있게 성장합니다.",
    desc:
      "다양한 경력의 현직 마케터와 12주를 함께\n" +
      "합니다. 실전과 같은 피드백으로 압축 성장합니다.",
  },
];
